var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30D1\\u30B9_13073",
    "data-name": "\\u30D1\\u30B9 13073",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10044",
    "data-name": "\\u9577\\u65B9\\u5F62 10044",
    width: 18,
    height: 18,
    transform: "translate(6 6)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_13073-2",
    "data-name": "\\u30D1\\u30B9 13073",
    d: "M-67.615-30.923A11.862,11.862,0,0,0-79.477-19.061,11.862,11.862,0,0,0-67.615-7.2,11.862,11.862,0,0,0-55.753-19.061,11.862,11.862,0,0,0-67.615-30.923ZM-68.8-9.655a9.476,9.476,0,0,1-8.3-9.406,9.616,9.616,0,0,1,.249-2.123l5.682,5.682v1.186A2.372,2.372,0,0,0-68.8-11.944h0Zm8.185-3.013a2.353,2.353,0,0,0-2.254-1.649h-1.186v-3.559a1.187,1.187,0,0,0-1.186-1.186H-72.36v-2.372h2.372A1.187,1.187,0,0,0-68.8-22.62h0v-2.372h2.372a2.372,2.372,0,0,0,2.372-2.372h0v-.486A9.468,9.468,0,0,1-58.813-15.53,9.472,9.472,0,0,1-60.617-12.668Z",
    transform: "translate(79.477 30.923)",
    fill: "#676767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSite);
export default __webpack_public_path__ + "static/media/icon_site.71a97e6b629ee81ba60cfd3c0f57cddf.svg";
export { ForwardRef as ReactComponent };